//@flow

import React from 'react';
import formStyles from '../styles/FormGeneral.scss';

type ComponentProps = {|
    text: Element,
|};

export const SubText = ({ text }: ComponentProps) => {
    return <div className={formStyles.text}>{text}</div>;
};
